import React, { useState, useEffect } from "react";
import Layout from "../Layout";
import { Button } from "@mui/material";
import axios from "axios";
import { useParams } from "react-router-dom";
import MaterialTable from "@material-table/core";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import SouthIcon from "@mui/icons-material/South";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";

const Operations = () => {
  const { id, worker } = useParams();
  const [operationsList, setOperationsList] = useState([]);
  const [selectedPosition, setSelectedPosition] = useState([]);
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const GetData = async () => {
    try {
      setLoading(true);
      const getOperations = await axios.get(
        "http://83.144.125.123:5222/Document/GetOperations",
        {
          params: {
            originId: id,
            worker: worker,
          },
        }
      );

      setOperationsList(getOperations.data);

      const getPositionForWorkerResponse = await axios.get(
        "http://83.144.125.123:5222/Document/GetPositionDetails",
        {
          params: {
            worker: worker,
            originId: id,
          },
        }
      );

      setSelectedPosition(getPositionForWorkerResponse.data);

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
      alert(
        "Wystapił nieoczekiwany błąd podczas wywołania funkcji /Operations/GetData. Skontaktuj się z administratorem systemu. Komuniakt zwrotny: "
      );
    }
  };

  const goBack = () => {
    history.push("/" + worker);
    history.go();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    GetData();
  }, []);

  useEffect(() => {
    const handleBrowserBack = () => {
      history.push("/" + worker);
      history.go();
    };

    // Add the event listener for the browser's back button
    window.addEventListener("popstate", handleBrowserBack);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("popstate", handleBrowserBack);
    };
  }, [history]);

  const handleRowClick = (event, rowData) => {
    history.push(
      "/realization/" +
        rowData.originId +
        "/" +
        rowData.documentId +
        "/" +
        worker
    );
    history.go();
  };

  const options = {
    pageSize: -1,
    paging: false,
    search: false,
    whiteSpace: "pre-wrap",
  };

  const renderCode = (rowData) => {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: rowData.code.replace("<br>", "<br>"),
        }}
      />
    );
  };

  return (
    <Layout>
      <div className="positions-container">
        {loading && (
          <div className="loading-overlay">
            <div className="loading-spinner"></div>
          </div>
        )}
        <Button
          variant="contained"
          color="primary"
          startIcon={<ArrowBackIcon />}
          onClick={goBack}
        >
          Powrót
        </Button>
        <div className="section">
          <Table>
            <TableBody>
              <TableRow>
                <TableCell className="firstcolumn">
                  <b>Pracownik</b>
                </TableCell>
                <TableCell>{worker}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="firstcolumn">
                  <b>Zlecenie</b>
                </TableCell>
                <TableCell>{selectedPosition.documentNumber}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="firstcolumn">
                  <b>Pozycja</b>
                </TableCell>
                <TableCell>{selectedPosition.originNo}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="firstcolumn">
                  <b>Produkt</b>
                </TableCell>
                <TableCell>
                  {selectedPosition.code} {selectedPosition.name}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
        <div className="info-label">
          Wybierz operację do zrealizowania <SouthIcon />
        </div>
        <div className="datatable">
          <MaterialTable
            columns={[
              { title: "Kod", field: "code", width: "30%", render: renderCode },
              { title: "Nazwa", field: "name" },
              { title: "Gniazdo", field: "documentNumber" },
              { title: "Ilość", field: "quantity" },
              {
                title: "Zrealizowano",
                field: "realized",
                cellStyle: (rowData) => ({
                  fontWeight: "bold",
                }),
              },
              {
                title: "Rozpoczęcie",
                field: "operationStart",
                cellStyle: (rowData) => {
                  return rowData.toString() !== "0001-01-01T00:00:00"
                    ? { backgroundColor: "#66de66" }
                    : null;
                },
                render: (rowData) => {
                  if (
                    rowData.operationStart.toString() !== "0001-01-01T00:00:00"
                  ) {
                    return new Date(rowData.operationStart).toLocaleString(
                      "pl-PL",
                      {
                        timeZone: "Europe/Warsaw",
                        hour12: false,
                      }
                    );
                  } else {
                    return "-";
                  }
                },
              },
              {
                title: "Pracownik",
                field: "worker",
                cellStyle: (rowData) => {
                  return rowData.toString() !== ""
                    ? { backgroundColor: "#66de66" }
                    : null;
                },
              },
            ]}
            data={operationsList}
            options={options}
            onRowClick={handleRowClick}
            title="Operacje"
            parentChildData={(row, rows) =>
              rows.find((a) => a.documentId === row.parentId)
            }
          />
        </div>
      </div>
      <br />
      <small className="rightsText">
        © 2023 — Aplikacja{" "}
        <a
          href="https://www.center.pl/"
          target={"_blank"}
          className="clearLink"
        >
          Computer Center
        </a>
        . Wszelkie prawa zastrzeżone
      </small>
    </Layout>
  );
};

export default Operations;
